export default __webpack_public_path__ + "static/media/il-borgo-gallery-5-moris-lorenzi.eece488b.jpg";